// extracted by mini-css-extract-plugin
export default {"closeChatContainer":"CloseChatPanel_closeChatContainer__gyybg","btnsContainer":"CloseChatPanel_btnsContainer__uGhjf"};